import {ModuleComponent} from "../../js/module-component";
import {GvfService} from "../../../gvf/js/gvf-service";
import {GvfUiService} from "../../../gvf/js/gvf-ui-service";

export class ModWebProjectList extends ModuleComponent {

    ready() {
        super.ready();

        const outdoorDiv = document.querySelector(this.scope +'__outdoor');
        const indoorDiv = document.querySelector(this.scope +'__indoor');

        this.findMember("outdoor").click(
            (ev)=>{
                ev.preventDefault();
                GvfService.endpoint('/web/web-project/get-web-inspiration-project-by-type', {
                    webProjectTypeId:1
                }).then((resp) => {
                    if (resp.html) {
                        const contentDiv = document.getElementById('projectList');
                        contentDiv.innerHTML = resp.html;
                        GvfUiService.init($(resp.html));
                    }
                });
                indoorDiv.classList.remove("active");
                outdoorDiv.classList.add("active");
            }
        );

        this.findMember("indoor").click(
            (ev)=>{
                ev.preventDefault();
                GvfService.endpoint('/web/web-project/get-web-inspiration-project-by-type', {
                    webProjectTypeId:2
                }).then((resp) => {
                    if (resp.html) {
                        const contentDiv = document.getElementById('projectList');
                        contentDiv.innerHTML = resp.html;
                        GvfUiService.init($(resp.html));
                    }
                });
                outdoorDiv.classList.remove("active");
                indoorDiv.classList.add("active");
            }
        );

    }

}